import {
    SET_PROJECT_STATE,
    SET_PROJECT_NAME,
    SET_PROJECT_STREET,
    SET_PROJECT_STREET_2,
    SET_PROJECT_ZIP,
    SET_PROJECT_CITY,
    SET_PROJECT_COUNTRY,
    SET_PROJECT_ADDRESS,
} from './constants';

export const setProjectAddress = address => ({
    type: SET_PROJECT_ADDRESS,
    address,
});

export const setProjectCity = projectCity => ({
    type: SET_PROJECT_CITY,
    projectCity,
});

export const setProjectCountry = projectCountry => ({
    type: SET_PROJECT_COUNTRY,
    projectCountry,
});

export const setProjectState = projectState => ({
    type: SET_PROJECT_STATE,
    projectState,
});

export const setProjectName = projectName => ({
    type: SET_PROJECT_NAME,
    projectName,
});

export const setProjectStreet = projectStreet => ({
    type: SET_PROJECT_STREET,
    projectStreet,
});

export const setProjectStreet2 = projectStreet2 => ({
    type: SET_PROJECT_STREET_2,
    projectStreet2,
});

export const setProjectZip = projectZip => ({
    type: SET_PROJECT_ZIP,
    projectZip,
});



// WEBPACK FOOTER //
// ./src/containers/common/projectaddress/actions.js